(this.webpackJsonpfit = this.webpackJsonpfit || []).push([
    [0],
    {
        18: function (e, t, n) {
            e.exports = n(27);
        },
        23: function (e, t, n) {},
        27: function (e, t, n) {
            "use strict";
            n.r(t);
            var a = n(0),
                r = n.n(a),
                i = n(11),
                c = n.n(i),
                o = (n(23), n(1)),
                s = r.a.createContext(["adults", function () {}]),
                u = r.a.createContext(["male", function () {}]),
                l = r.a.createContext(["long", function () {}]),
                d = r.a.createContext([{ age: "adults", style: "long", gender: "male", height: void 0, chest: void 0, waist: void 0, dressSize: void 0 }, function () {}]),
                p = r.a.createContext(["cm", function () {}]),
                m = r.a.createContext(["uk", function () {}]),
                g = n(4),
                f = n(2),
                h = n(3),
                x = n(12),
                b = function () {
                    document.body.classList.remove("lockScrolling"), document.getElementsByClassName("fit-wrapper")[0].classList.remove("showFit");
                },
                S = function (e, t) {
                    var n,
                        a = Object(x.a)(Object.entries(e.height).entries());
                    try {
                        for (a.s(); !(n = a.n()).done; ) {
                            var r = Object(o.a)(n.value, 2),
                                i = r[0],
                                c = Object(o.a)(r[1], 2),
                                s = c[0],
                                u = c[1];
                            if (0 === i && t.height < u[0]) return console.log("Height input < smallest data; matching smallest size"), s;
                            if (i === Object.entries(e.height).length - 1 && t.height > u[1]) return console.log("Height input > largest data; matching smallest size"), s;
                            if (u[0] <= t.height && t.height <= u[1]) {
                                console.log("Match found for size ".concat(s, "; checking for match in size range above"));
                                var l = e.height[Object.keys(e.height)[i + 1]];
                                try {
                                    if (!(l[0] <= t.height && t.height <= l[1])) return console.log("No match found in size range above, returning size ".concat(s)), s;
                                    if ((console.log("Match also found in size range above ".concat(Object.keys(e.height)[i + 1])), t.chest > 0))
                                        if (t.chest > t.waist) {
                                            console.log("Chest measurement is larger; using value ".concat(t.chest, " to find secondary match"));
                                            var d = e.chest[Object.keys(e.chest)[i]],
                                                p = e.chest[Object.keys(e.chest)[i + 1]];
                                            if (t.chest < d[0]) return console.log("Chest input < smallest data; matching with chest size ".concat(s)), s;
                                            if (t.chest > p[1]) return console.log("Chest input > largest data; matching with chest size ".concat(s)), Object.keys(e.chest)[i + 1];
                                            if ((console.log("Checking chest against range ".concat(e.chest[Object.keys(e.chest)[i]])), d[0] <= t.chest && t.chest <= d[1]))
                                                return console.log("Match found for chest size ".concat(s, " with range ").concat(u)), s;
                                            if ((console.log("Checking chest against range ".concat(e.chest[Object.keys(e.chest)[i + 1]])), p[0] <= t.chest && t.chest <= p[1]))
                                                return console.log("Match found for chest size ".concat(Object.keys(e.chest)[i + 1], " with range ").concat(e.chest[Object.keys(e.chest)[i + 1]])), Object.keys(e.chest)[i + 1];
                                            console.error("No match found for chest");
                                        } else {
                                            console.log("Waist measurement is larger; using value ".concat(t.waist, " to find secondary match"));
                                            var m = e.waist[Object.keys(e.waist)[i]],
                                                g = e.waist[Object.keys(e.waist)[i + 1]];
                                            if (t.waist < m[0]) return console.log("Waist input < smallest data; matching with waist size ".concat(s)), s;
                                            if (t.waist > g[1]) return console.log("Waist input > largest data; matching with waist size ".concat(s)), Object.keys(e.waist)[i + 1];
                                            if ((console.log("Checking waist against range ".concat(e.waist[Object.keys(e.waist)[i]])), m[0] <= t.waist && t.waist <= m[1]))
                                                return console.log("Match found for waist size ".concat(s, " with range ").concat(u)), s;
                                            if ((console.log("Checking waist against range ".concat(e.waist[Object.keys(e.waist)[i + 1]])), g[0] <= t.waist && t.waist <= g[1]))
                                                return console.log("Match found for waist size ".concat(Object.keys(e.waist)[i + 1], " with range ").concat(e.waist[Object.keys(e.waist)[i + 1]])), Object.keys(e.waist)[i + 1];
                                            console.error("No match found for waist");
                                        }
                                    else {
                                        console.log("Using dress size value ".concat(t.dressSize, " to find secondary match"));
                                        var f = e.dressSize[Object.keys(e.dressSize)[i]],
                                            h = e.dressSize[Object.keys(e.dressSize)[i + 1]];
                                        if (t.dressSize < f[0]) return console.log("Dress size input < smallest data; matching with dress size ".concat(s)), s;
                                        if (t.dressSize > h[1]) return console.log("Dress size input > largest data; matching with dress size ".concat(s)), Object.keys(e.dressSize)[i + 1];
                                        if ((console.log("Checking dressSize against range ".concat(e.dressSize[Object.keys(e.dressSize)[i]])), f[0] <= t.dressSize && t.dressSize <= f[1]))
                                            return console.log("Match found for dressSize size ".concat(s, " with range ").concat(u)), s;
                                        if ((console.log("Checking dressSize against range ".concat(e.dressSize[Object.keys(e.dressSize)[i + 1]])), h[0] <= t.dressSize && t.dressSize <= h[1]))
                                            return console.log("Match found for dressSize size ".concat(Object.keys(e.dressSize)[i + 1], " with range ").concat(e.dressSize[Object.keys(e.dressSize)[i + 1]])), Object.keys(e.dressSize)[i + 1];
                                        console.error("No match found for dress size");
                                    }
                                } catch (e) {
                                    return console.log("Cannot find perfect match for this size input"), console.log("Making best recommendation ".concat(s)), s;
                                }
                            }
                        }
                    } catch (e) {
                        a.e(e);
                    } finally {
                        a.f();
                    }
                },
                v = function (e, t, n) {
                    return Array.isArray(e) ? ("changing" === t ? n[e[0]] : "general" === t ? n[e[1]] : void console.error("No mapping available for this recommended size title")) : n[e];
                },
                j = function (e) {
                    return 2.54 * e;
                },
                O = function (e) {
                    return e / 2.54;
                },
                y = function (e) {
                    return [Math.floor(e / 30.48), Math.round((e % 30.48) / 2.54)];
                };
            function w() {
                var e = Object(f.a)([
                    "\n  position: absolute;\n  top: 40px;\n  left: 40px;\n\n  color: #ed523e;\n  font-size: 42px;\n  line-height: 0.5em;\n\n  cursor: pointer;\n\n  @media (max-width: 1024px) {\n    top: 15px;\n    left: 15px;\n  }\n",
                ]);
                return (
                    (w = function () {
                        return e;
                    }),
                    e
                );
            }
            function z() {
                var e = Object(f.a)([
                    "\n  position: absolute;\n  top: 40px;\n  right: 40px;\n\n  color: #ed523e;\n  font-size: 42px;\n  line-height: 0.5em;\n\n  cursor: pointer;\n\n  @media (max-width: 1024px) {\n    top: 15px;\n    right: 15px;\n  }\n",
                ]);
                return (
                    (z = function () {
                        return e;
                    }),
                    e
                );
            }
            function k() {
                var e = Object(f.a)([
                    "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100vh;\n\n  box-sizing: border-box;\n  padding: 30px 0 60px;\n\n  opacity: 1;\n  transition: opacity 200ms ease;\n\n  ",
                    "\n\n  @media (max-width: 767px) {\n    height: auto;\n    padding-bottom: 100px;\n  }\n",
                ]);
                return (
                    (k = function () {
                        return e;
                    }),
                    e
                );
            }
            var E = h.a.div(k(), function (e) {
                    return e.imagesHaveLoaded && "opacity: 1;";
                }),
                C = h.a.div(z()),
                M = h.a.div(w()),
                A = function (e) {
                    var t = Object(a.useContext)(s),
                        n = Object(o.a)(t, 1)[0];
                    return r.a.createElement(
                        E,
                        { imagesHaveLoaded: e.imagesHaveLoaded },
                        r.a.createElement(
                            C,
                            {
                                id: "fitClose",
                                onClick: function () {
                                    return b();
                                },
                            },
                            "×"
                        ),
                        0 !== e.currentSlide &&
                            r.a.createElement(
                                M,
                                {
                                    onClick: function () {
                                        return 3 === e.currentSlide && "kids" === n ? e.updateCurrentSlide(e.currentSlide - 2) : e.updateCurrentSlide(e.currentSlide - 1);
                                    },
                                },
                                "←"
                            ),
                        e.children
                    );
                };
            function I() {
                var e = Object(f.a)([
                    "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n\n  max-width: 840px;\n\n  font-size: 13px;\n  letter-spacing: 1px;\n  color: #000;\n  text-align: center;\n\n  > *:first-child {\n    flex: 1;\n    margin: 0 35px;\n    ",
                    "\n  }\n  > *:last-child {\n    flex: 1;\n    margin: 0 35px;\n    ",
                    "\n  }\n\n  @media (max-width: 1024px) {\n    font-size: 12px;\n    > * {\n      display: none;\n    }\n    > *:first-child {\n      ",
                    "\n    }\n    > *:last-child {\n      ",
                    "\n    }\n  }\n",
                ]);
                return (
                    (I = function () {
                        return e;
                    }),
                    e
                );
            }
            function L() {
                var e = Object(f.a)([
                    "\n  opacity: 0.6;\n\n  cursor: pointer;\n  transition: opacity 0.5s ease;\n\n  &:first-child {\n    margin-right: 60px;\n    ",
                    "\n  }\n  &:last-child {\n    margin-left: 60px;\n    ",
                    "\n  }\n\n  // HD+\n  max-height: 600px;\n\n  // HD\n  @media (max-height: 1080px) {\n    max-height: 380px;\n    ",
                    "\n    &:first-child {\n      margin-right: 120px;\n      ",
                    "\n    }\n    &:last-child {\n      margin-left: 120px;\n      ",
                    "\n    }\n  }\n\n  // laptop 15\n  @media (max-width: 1440px) {\n    max-height: 275px;\n    ",
                    "\n    &:first-child {\n      margin-right: 140px;\n      ",
                    "\n    }\n    &:last-child {\n      margin-left: 140px;\n      ",
                    "\n    }\n  }\n\n  // laptop 13\n  @media (max-width: 1367px) {\n    max-height: 230px;\n    ",
                    "\n    &:first-child {\n      margin-right: 140px;\n      ",
                    "\n    }\n    &:last-child {\n      margin-left: 140px;\n      ",
                    "\n    }\n  }\n\n  // iPad Air - portrait\n  @media (max-height: 1279px) and (orientation: portrait) {\n    max-height: 450px;\n    &:first-child {\n      margin-right: 140px;\n    }\n    &:last-child {\n      margin-left: 140px;\n    }\n  }\n\n  // mobile\n  @media (max-width: 767px) and (orientation: portrait) {\n    max-height: 180px;\n  }\n",
                ]);
                return (
                    (L = function () {
                        return e;
                    }),
                    e
                );
            }
            function H() {
                var e = Object(f.a)([
                    "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  > *:first-child {\n    margin-right: 140px;\n  }\n  > *:last-child {\n    margin-left: 140px;\n  }\n\n  @media (max-width: 1024px) {\n    > *:first-child {\n      margin-right: 35px !important;\n    }\n    > *:last-child {\n      margin-left: 35px !important;\n    }\n  }\n",
                ]);
                return (
                    (H = function () {
                        return e;
                    }),
                    e
                );
            }
            function D() {
                var e = Object(f.a)([
                    "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 140px;\n  height: 40px;\n\n  background: #999;\n\n  text-align: center;\n  color: rgba(255, 255, 255, 0.4);\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 13px;\n\n  cursor: pointer;\n\n  &:first-child {\n    ",
                    "\n  }\n  &:last-child {\n    ",
                    "\n  }\n\n  @media (max-width: 1024px) {\n    height: 36px;\n    width: 100%;\n    font-size: 12px;\n  }\n",
                ]);
                return (
                    (D = function () {
                        return e;
                    }),
                    e
                );
            }
            function V() {
                var e = Object(f.a)([
                    "\n  width: 560px;\n  max-width: 560px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: auto auto 30px auto;\n\n  @media (max-width: 1024px) {\n    width: calc(100vw - 100px);\n    max-width: 100vw;\n    align-items: center;\n    margin-bottom: 10px;\n\n    ",
                    "\n  }\n",
                ]);
                return (
                    (V = function () {
                        return e;
                    }),
                    e
                );
            }
            function P() {
                var e = Object(f.a)([""]);
                return (
                    (P = function () {
                        return e;
                    }),
                    e
                );
            }
            var T = h.a.div(P()),
                F = h.a.div(V(), function (e) {
                    return !e.isRowMobile && "\n      flex-direction: column;\n      > *:first-child {\n        margin-bottom: 12px;\n      }\n    ";
                }),
                N = h.a.div(
                    D(),
                    function (e) {
                        return e.currentState === e.values[0] && "background-color: #ED523E;\n      color: #fff;\n      cursor: pointer;";
                    },
                    function (e) {
                        return e.currentState === e.values[1] && "background-color: #ED523E;\n      color: #fff;\n      cursor: auto;";
                    }
                ),
                _ = h.a.div(H()),
                W = h.a.img(
                    L(),
                    function (e) {
                        return e.currentState === e.values[0] && "opacity: 1;\n      cursor: auto;";
                    },
                    function (e) {
                        return e.currentState === e.values[1] && "opacity: 1;\n      cursor: auto;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "max-height: 290px;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "margin-right: 140px;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "margin-left: 140px;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "max-height: 230px;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "margin-right: 175px;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "margin-left: 175px;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "max-height: 150px;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "margin-right: 155px;";
                    },
                    function (e) {
                        return 4 === e.currentSlide && "margin-left: 155px;";
                    }
                ),
                G = h.a.div(
                    I(),
                    function (e) {
                        return e.currentState === e.values[0] ? "opacity: 1;" : "opacity: 0.6";
                    },
                    function (e) {
                        return e.currentState === e.values[1] ? "opacity: 1;" : "opacity: 0.6";
                    },
                    function (e) {
                        return e.currentState === e.values[0] && "display: block;";
                    },
                    function (e) {
                        return e.currentState === e.values[1] && "display: block;";
                    }
                ),
                q = function (e) {
                    var t = Object(a.useState)(!1),
                        n = Object(o.a)(t, 2),
                        i = n[0],
                        c = n[1],
                        u = Object(a.useState)(!1),
                        l = Object(o.a)(u, 2),
                        d = l[0],
                        p = l[1],
                        m = Object(a.useContext)(s),
                        g = Object(o.a)(m, 1)[0];
                    Object(a.useEffect)(
                        function () {
                            e.updateImageLoadStatus && i && d && e.updateImageLoadStatus(!0);
                        },
                        [i, d]
                    );
                    var f = {},
                        h = {};
                    return (
                        0 !== e.currentSlide
                            ? ((f["data-track"] = ""
                                  .concat(g, "-")
                                  .concat(e.currentSlide + 1, "-")
                                  .concat(e.values[0])),
                              (h["data-track"] = ""
                                  .concat(g, "-")
                                  .concat(e.currentSlide + 1, "-")
                                  .concat(e.values[1])))
                            : ((f["data-track"] = "".concat(e.currentSlide + 1, "-").concat(e.values[0])), (h["data-track"] = "".concat(e.currentSlide + 1, "-").concat(e.values[1]))),
                        r.a.createElement(
                            T,
                            null,
                            r.a.createElement(
                                F,
                                {
                                    onClick: function () {
                                        return e.switchAction(e.currentState === e.values[0] ? e.values[1] : e.values[0]);
                                    },
                                    isRowMobile: e.isRowMobile,
                                },
                                r.a.createElement(N, Object.assign({ currentState: e.currentState, values: e.values }, f), e.text[0]),
                                r.a.createElement(N, Object.assign({ currentState: e.currentState, values: e.values }, h), e.text[1])
                            ),
                            e.images &&
                                r.a.createElement(
                                    _,
                                    null,
                                    r.a.createElement(W, {
                                        src: e.images[0],
                                        alt: "adults",
                                        onClick: function () {
                                            return e.switchAction(e.currentState === e.values[0] ? e.values[1] : e.values[0]);
                                        },
                                        currentState: e.currentState,
                                        values: e.values,
                                        onLoad: function () {
                                            return c(!0);
                                        },
                                        currentSlide: e.currentSlide,
                                    }),
                                    r.a.createElement(W, {
                                        src: e.images[1],
                                        alt: "kids",
                                        onClick: function () {
                                            return e.switchAction(e.currentState === e.values[0] ? e.values[1] : e.values[0]);
                                        },
                                        currentState: e.currentState,
                                        values: e.values,
                                        onLoad: function () {
                                            return p(!0);
                                        },
                                        currentSlide: e.currentSlide,
                                    })
                                ),
                            e.explanationText && r.a.createElement(G, { currentState: e.currentState, values: e.values }, r.a.createElement("p", null, e.explanationText[0]), r.a.createElement("p", null, e.explanationText[1]))
                        )
                    );
                };
            function B() {
                var e = Object(f.a)([
                    "\n  height: 40px;\n  width: 240px;\n\n  border: none;\n  margin-top: 30px;\n\n  background-color: #ed523e;\n\n  color: #fff;\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: bold;\n  letter-spacing: 1px;\n\n  cursor: pointer;\n\n  @media (max-width: 1024px) {\n    height: 36px;\n    margin-top: 20px;\n    font-size: 12px;\n  }\n",
                ]);
                return (
                    (B = function () {
                        return e;
                    }),
                    e
                );
            }
            function R() {
                var e = Object(f.a)(["\n  margin-top: 0;\n  margin-bottom: 30px;\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    margin: 20px;\n    font-size: 21px;\n  }\n"]);
                return (
                    (R = function () {
                        return e;
                    }),
                    e
                );
            }
            var U = h.a.h1(R()),
                K = h.a.button(B()),
                J = function (e) {
                    var t = Object(a.useContext)(s),
                        n = Object(o.a)(t, 2),
                        i = n[0],
                        c = n[1],
                        u = Object(a.useContext)(d),
                        l = Object(o.a)(u, 2)[1],
                        p = Object(a.useState)(!1),
                        m = Object(o.a)(p, 2),
                        f = m[0],
                        h = m[1],
                        x = {};
                    return (
                        0 !== e.currentSlide ? (x["data-track"] = "".concat(i, "-").concat(e.currentSlide + 1, "-age-continue")) : (x["data-track"] = "".concat(e.currentSlide + 1, "-age-continue")),
                        r.a.createElement(
                            A,
                            { currentSlide: e.currentSlide, updateCurrentSlide: e.updateCurrentSlide, imagesHaveLoaded: f },
                            r.a.createElement(U, null, "Who's it for?"),
                            r.a.createElement(q, {
                                values: ["adults", "kids"],
                                text: ["Adults", "Kids"],
                                images: ["https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-woman-LS.jpg?v=1677587644", "https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-girl-LS.jpg?v=1677587644"],
                                currentState: i,
                                switchAction: function (e) {
                                    c(e),
                                        l(function (t) {
                                            return Object(g.a)(Object(g.a)({}, t), {}, { age: e });
                                        });
                                },
                                updateImageLoadStatus: h,
                                currentSlide: e.currentSlide,
                            }),
                            r.a.createElement(
                                K,
                                Object.assign(
                                    {
                                        className: "selectAge",
                                        onClick: function () {
                                            e.updateCurrentSlide(e.currentSlide + 1);
                                        },
                                    },
                                    x
                                ),
                                "Continue"
                            )
                        )
                    );
                };
            function Q() {
                var e = Object(f.a)([
                    "\n  height: 40px;\n  width: 240px;\n\n  border: none;\n  margin-top: 30px;\n\n  background-color: #ed523e;\n\n  color: #fff;\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: bold;\n  letter-spacing: 1px;\n\n  cursor: pointer;\n\n  @media (max-width: 1024px) {\n    height: 36px;\n    margin-top: 20px;\n    font-size: 12px;\n  }\n",
                ]);
                return (
                    (Q = function () {
                        return e;
                    }),
                    e
                );
            }
            function X() {
                var e = Object(f.a)(["\n  font-size: 13px;\n  letter-spacing: px;\n  color: #666;\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    margin-left: 7.5px;\n    margin-right: 7.5px;\n    font-size: 12px;\n  }\n"]);
                return (
                    (X = function () {
                        return e;
                    }),
                    e
                );
            }
            function Y() {
                var e = Object(f.a)(["\n  margin-top: 0;\n  margin-bottom: 30px;\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    margin: 20px;\n    font-size: 21px;\n  }\n"]);
                return (
                    (Y = function () {
                        return e;
                    }),
                    e
                );
            }
            var Z = h.a.h1(Y()),
                $ = h.a.p(X()),
                ee = h.a.button(Q()),
                te = function (e) {
                    var t = Object(a.useContext)(s),
                        n = Object(o.a)(t, 1)[0],
                        i = Object(a.useContext)(u),
                        c = Object(o.a)(i, 2),
                        l = c[0],
                        p = c[1],
                        m = Object(a.useContext)(d),
                        f = Object(o.a)(m, 2)[1],
                        h = Object(a.useState)(!1),
                        x = Object(o.a)(h, 2),
                        b = x[0],
                        S = x[1],
                        v = function (e) {
                            p(e),
                                f(function (t) {
                                    return Object(g.a)(Object(g.a)({}, t), {}, { gender: e });
                                });
                        },
                        j = {};
                    return (
                        0 !== e.currentSlide ? (j["data-track"] = "".concat(n, "-").concat(e.currentSlide + 1, "-gender-continue")) : (j["data-track"] = "".concat(e.currentSlide + 1, "-gender-continue")),
                        r.a.createElement(
                            A,
                            { currentSlide: e.currentSlide, updateCurrentSlide: e.updateCurrentSlide, imagesHaveLoaded: b },
                            r.a.createElement(Z, null, "Who's it for?"),
                            "adults" === n
                                ? r.a.createElement(q, {
                                      values: ["male", "female"],
                                      text: ["Male", "Female"],
                                      currentState: l,
                                      switchAction: v,
                                      images: ["https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-Man-LS.jpg?v=1677587644", "https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-woman-LS.jpg?v=1677587644"],
                                      updateImageLoadStatus: S,
                                      currentSlide: e.currentSlide,
                                  })
                                : r.a.createElement(q, {
                                      values: ["male", "female"],
                                      text: ["Boy", "Girl"],
                                      currentState: l,
                                      switchAction: v,
                                      images: [
                                          "https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-boy-LS.jpg?v=1677587644",
                                          "https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-girl-LS.jpg?v=1677587644",
                                      ],
                                      updateImageLoadStatus: S,
                                      currentSlide: e.currentSlide,
                                  }),
                            r.a.createElement($, null, "Whilst dryobe Advance is a unisex garment, selecting gender may help you find the best size."),
                            r.a.createElement(
                                ee,
                                Object.assign(
                                    {
                                        className: "selectGender",
                                        onClick: function () {
                                            "adults" === n ? e.updateCurrentSlide(e.currentSlide + 1) : e.updateCurrentSlide(e.currentSlide + 2);
                                        },
                                    },
                                    j
                                ),
                                "Continue"
                            )
                        )
                    );
                };
            function ne() {
                var e = Object(f.a)([
                    "\n  height: 40px;\n  width: 240px;\n\n  border: none;\n  margin-top: 30px;\n\n  background-color: #ed523e;\n\n  color: #fff;\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: bold;\n  letter-spacing: 1px;\n\n  cursor: pointer;\n\n  @media (max-width: 1024px) {\n    height: 36px;\n    margin-top: 20px;\n    font-size: 12px;\n  }\n",
                ]);
                return (
                    (ne = function () {
                        return e;
                    }),
                    e
                );
            }
            function ae() {
                var e = Object(f.a)(["\n  margin-top: 0;\n  margin-bottom: 30px;\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    margin: 20px;\n    font-size: 21px;\n  }\n"]);
                return (
                    (ae = function () {
                        return e;
                    }),
                    e
                );
            }
            var re = h.a.h1(ae()),
                ie = h.a.button(ne()),
                ce = function (e) {
                    var t = Object(a.useContext)(s),
                        n = Object(o.a)(t, 1)[0],
                        i = Object(a.useContext)(u),
                        c = Object(o.a)(i, 1)[0],
                        p = Object(a.useContext)(l),
                        m = Object(o.a)(p, 2),
                        f = m[0],
                        h = m[1],
                        x = Object(a.useContext)(d),
                        b = Object(o.a)(x, 2)[1],
                        S = Object(a.useState)(!1),
                        v = Object(o.a)(S, 2),
                        j = v[0],
                        O = v[1],
                        y = {};
                    return (
                        0 !== e.currentSlide ? (y["data-track"] = "".concat(n, "-").concat(e.currentSlide + 1, "-style-continue")) : (y["data-track"] = "".concat(e.currentSlide + 1, "-style-continue")),
                        r.a.createElement(
                            A,
                            { currentSlide: e.currentSlide, updateCurrentSlide: e.updateCurrentSlide, imagesHaveLoaded: j },
                            r.a.createElement(re, null, "Which style of dryrobe is right for you?"),
                            r.a.createElement(q, {
                                values: ["long", "short"],
                                text: ["Long sleeve", "Short sleeve"],
                                currentState: f,
                                switchAction: function (e) {
                                    h(e),
                                        b(function (t) {
                                            return Object(g.a)(Object(g.a)({}, t), {}, { style: e });
                                        });
                                },
                                images:
                                    "male" === c
                                        ? ["https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-Man-LS.jpg?v=1677587644", "https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-man-SS.jpg?v=1677587644"]
                                        : ["https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-woman-LS.jpg?v=1677587644", "https://cdn.shopify.com/s/files/1/0398/0253/files/SizeFinder-woman-SS.jpg?v=1677587644"],
                                explanationText: [
                                    "The extra warmth provided by the dryrobe Advance Long Sleeve is ideal for anyone hanging around at events or spectating, whilst providing plenty of room to get changed in.",
                                    "If you want to change as quickly as possible, a dryrobe Advance Short Sleeve will offer warm fast changing in any climate.",
                                ],
                                updateImageLoadStatus: O,
                                currentSlide: e.currentSlide,
                            }),
                            r.a.createElement(
                                ie,
                                Object.assign(
                                    {
                                        className: "selectStyle",
                                        onClick: function () {
                                            e.updateCurrentSlide(e.currentSlide + 1);
                                        },
                                    },
                                    y
                                ),
                                "Continue"
                            )
                        )
                    );
                },
                oe = n(16);
            function se() {
                var e = Object(f.a)([
                    "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  height: 36px;\n\n  background: #999;\n\n  text-align: center;\n  color: rgba(255, 255, 255, 0.4);\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 12px;\n\n  cursor: pointer;\n\n  ",
                    "\n",
                ]);
                return (
                    (se = function () {
                        return e;
                    }),
                    e
                );
            }
            function ue() {
                var e = Object(f.a)([
                    "\n  width: calc(100vw - 30px);\n  max-width: 100vw;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: auto auto 10px auto;\n\n  > * {\n    margin: 0 6px;\n  }\n  > *:first-child {\n    margin-left: 0;\n  }\n  > *:last-child {\n    margin-right: 0;\n  }\n\n  @media (min-width: 1025px) {\n    display: none;\n  }\n",
                ]);
                return (
                    (ue = function () {
                        return e;
                    }),
                    e
                );
            }
            function le() {
                var e = Object(f.a)([""]);
                return (
                    (le = function () {
                        return e;
                    }),
                    e
                );
            }
            var de = h.a.div(le()),
                pe = h.a.div(ue()),
                me = h.a.div(se(), function (e) {
                    return e.isActive && "background-color: #ED523E;\n    color: #fff;\n    cursor: pointer;";
                }),
                ge = function (e) {
                    return r.a.createElement(
                        de,
                        null,
                        r.a.createElement(
                            pe,
                            null,
                            e.states.map(function (t) {
                                return r.a.createElement(
                                    me,
                                    {
                                        key: t.value,
                                        onClick: function () {
                                            return e.switchAction(t.value);
                                        },
                                        isActive: e.currentState === t.value,
                                    },
                                    t.text
                                );
                            })
                        )
                    );
                };
            function fe() {
                var e = Object(f.a)([
                    '\n  > span {\n    position: relative;\n    cursor: pointer;\n  }\n  > span::after {\n    content: "";\n    display: block;\n    width: 100%;\n    height: 3px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n\n    opacity: 0;\n    background-color: #ed523e;\n\n    transition: opacity 0.1s ease;\n  }\n\n  > span',
                    "::after {\n    opacity: 1;\n  }\n",
                ]);
                return (
                    (fe = function () {
                        return e;
                    }),
                    e
                );
            }
            function he() {
                var e = Object(f.a)(["\n  margin-left: 5px;\n  font-size: 18px;\n  color: #666;\n  font-weight: bold;\n"]);
                return (
                    (he = function () {
                        return e;
                    }),
                    e
                );
            }
            function xe() {
                var e = Object(f.a)(["\n  width: 100px;\n\n  box-sizing: border-box;\n  padding: 13px 15px;\n  border: solid 2px rgba(0, 0, 0, 0.1);\n\n  font-size: 15px;\n"]);
                return (
                    (xe = function () {
                        return e;
                    }),
                    e
                );
            }
            function be() {
                var e = Object(f.a)(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n"]);
                return (
                    (be = function () {
                        return e;
                    }),
                    e
                );
            }
            function Se() {
                var e = Object(f.a)([
                    "\n  // HD+\n  max-height: 550px;\n\n  // HD\n  @media (max-height: 1080px) {\n    max-height: 330px;\n  }\n\n  // laptop 15\n  @media (max-width: 1440px) {\n    max-height: 225px;\n  }\n\n  // laptop 13\n  @media (max-width: 1367px) {\n    max-height: 180px;\n  }\n\n  // iPad Air - portrait\n  @media (max-height: 1279px) and (orientation: portrait) {\n    max-height: 400px;\n  }\n\n  // mobile\n  @media (max-width: 767px) and (orientation: portrait) {\n    max-height: 140px;\n  }\n",
                ]);
                return (
                    (Se = function () {
                        return e;
                    }),
                    e
                );
            }
            function ve() {
                var e = Object(f.a)(["\n  font-size: 18px;\n  text-transform: uppercase;\n  font-weight: bold;\n\n  @media (max-width: 1024px) {\n    margin-top: 0;\n    font-size: 12px;\n  }\n"]);
                return (
                    (ve = function () {
                        return e;
                    }),
                    e
                );
            }
            function je() {
                var e = Object(f.a)([
                    "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  margin: 0 120px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n  &:last-child {\n    margin-right: 0;\n  }\n\n  @media (max-width: 1024px) {\n    display: none;\n    margin: 0;\n\n    ",
                    "\n    ",
                    "\n    ",
                    "\n\n    ",
                    "\n    ",
                    "\n\n    ",
                    "\n  }\n",
                ]);
                return (
                    (je = function () {
                        return e;
                    }),
                    e
                );
            }
            var Oe = h.a.div(
                    je(),
                    function (e) {
                        return "adults" === e.currentAge && "male" === e.currentGender && 0 === e.currentMobilePanel && "\n    &:nth-child(1) {\n      display: flex;\n    }";
                    },
                    function (e) {
                        return "adults" === e.currentAge && "male" === e.currentGender && 1 === e.currentMobilePanel && "\n    &:nth-child(2) {\n      display: flex;\n    }";
                    },
                    function (e) {
                        return "adults" === e.currentAge && "male" === e.currentGender && 2 === e.currentMobilePanel && "\n    &:nth-child(3) {\n      display: flex;\n    }";
                    },
                    function (e) {
                        return "adults" === e.currentAge && "female" === e.currentGender && 0 === e.currentMobilePanel && "\n    &:nth-child(1) {\n      display: flex;\n    }";
                    },
                    function (e) {
                        return "adults" === e.currentAge && "female" === e.currentGender && 1 === e.currentMobilePanel && "\n    &:nth-child(2) {\n      display: flex;\n    }";
                    },
                    function (e) {
                        return "kids" === e.currentAge && "\n    &:nth-child(1) {\n      display: flex;\n    }";
                    }
                ),
                ye = h.a.p(ve()),
                we = h.a.img(Se()),
                ze = h.a.div(be()),
                ke = h.a.input(xe()),
                Ee = h.a.span(he()),
                Ce = Object(h.a)(Ee)(fe(), function (e) {
                    return "uk" === e.unitOfDressSize ? ":first-child" : ":last-child";
                }),
                Me = function (e) {
                    var t = Object(a.useContext)(s),
                        n = Object(o.a)(t, 1)[0],
                        i = Object(a.useContext)(u),
                        c = Object(o.a)(i, 1)[0];
                    return r.a.createElement(
                        Oe,
                        { currentMobilePanel: e.currentMobilePanel, currentAge: n, currentGender: c },
                        r.a.createElement(ye, null, e.inputHeading),
                        r.a.createElement(we, {
                            src: e.panelImage,
                            onLoad: function () {
                                return e.updateImageLoadStatus(!0);
                            },
                        }),
                        r.a.createElement(
                            ze,
                            null,
                            "height" === e.inputType && "inches" === e.unitOfMeasurement
                                ? r.a.createElement(
                                      r.a.Fragment,
                                      null,
                                      r.a.createElement(ke, {
                                          type: "number",
                                          min: "0",
                                          onChange: function (t) {
                                              return e.updateInputValue[0](parseFloat(t.target.value));
                                          },
                                          value: 0 !== e.inputValue[0] && e.inputValue[0],
                                      }),
                                      r.a.createElement(ke, {
                                          type: "number",
                                          min: "0",
                                          onChange: function (t) {
                                              return e.updateInputValue[1](parseFloat(t.target.value));
                                          },
                                          value: 0 !== e.inputValue[1] && e.inputValue[1],
                                      })
                                  )
                                : r.a.createElement(ke, {
                                      type: "number",
                                      min: "0",
                                      step: "dressSize" === e.inputType ? "2" : void 0,
                                      onChange: function (t) {
                                          return e.updateInputValue(parseFloat(t.target.value));
                                      },
                                      value: 0 !== e.inputValue && e.inputValue,
                                  }),
                            "dressSize" === e.inputType
                                ? r.a.createElement(
                                      Ce,
                                      {
                                          unitOfDressSize: e.unitOfDressSize,
                                          onClick: function () {
                                              return "uk" === e.unitOfDressSize ? e.updateUnitOfDressSize("eu") : e.updateUnitOfDressSize("uk");
                                          },
                                      },
                                      r.a.createElement("span", null, "UK"),
                                      "/",
                                      r.a.createElement("span", null, "EU")
                                  )
                                : r.a.createElement(Ee, null, "cm" === e.unitOfMeasurement ? "cm" : "height" === e.inputType ? "ft/in" : "in")
                        )
                    );
                };
            function Ae() {
                var e = Object(f.a)([
                    "\n  height: 40px;\n  width: 240px;\n\n  border: none;\n  margin-top: 30px;\n\n  background-color: #999;\n\n  color: #fff;\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: bold;\n  letter-spacing: 1px;\n\n  cursor: not-allowed;\n  pointer-events: none;\n\n  ",
                    "\n\n  ",
                    "\n\n  @media (max-width: 1024px) {\n    height: 36px;\n    margin-top: 20px;\n    font-size: 12px;\n  }\n",
                ]);
                return (
                    (Ae = function () {
                        return e;
                    }),
                    e
                );
            }
            function Ie() {
                var e = Object(f.a)(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"]);
                return (
                    (Ie = function () {
                        return e;
                    }),
                    e
                );
            }
            function Le() {
                var e = Object(f.a)(["\n  margin-top: 0;\n  margin-bottom: 20px;\n\n  font-size: 15px;\n  color: #666;\n"]);
                return (
                    (Le = function () {
                        return e;
                    }),
                    e
                );
            }
            function He() {
                var e = Object(f.a)(["\n  margin-top: 0;\n  margin-bottom: 30px;\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    margin: 20px;\n    font-size: 21px;\n  }\n"]);
                return (
                    (He = function () {
                        return e;
                    }),
                    e
                );
            }
            var De = h.a.h1(He()),
                Ve = h.a.p(Le()),
                Pe = h.a.div(Ie()),
                Te = h.a.button(
                    Ae(),
                    function (e) {
                        return e.isMobile && "\n    cursor: pointer;\n    pointer-events: auto;\n  ";
                    },
                    function (e) {
                        return e.measurementsAreValid && "\n    background-color: #ed523e;\n    cursor: pointer;\n    pointer-events: auto;\n  ";
                    }
                ),
                Fe = function (e) {
                    var t = Object(a.useContext)(s),
                        n = Object(o.a)(t, 1)[0],
                        i = Object(a.useContext)(u),
                        c = Object(o.a)(i, 1)[0],
                        l = Object(a.useContext)(d),
                        f = Object(o.a)(l, 2),
                        h = f[0],
                        x = f[1],
                        b = Object(a.useContext)(p),
                        S = Object(o.a)(b, 2),
                        v = S[0],
                        w = S[1],
                        z = Object(a.useContext)(m),
                        k = Object(o.a)(z, 2),
                        E = k[0],
                        C = k[1],
                        M = Object(a.useState)(!1),
                        I = Object(o.a)(M, 2),
                        L = I[0],
                        H = I[1],
                        D = Object(a.useState)(!1),
                        V = Object(o.a)(D, 2),
                        P = V[0],
                        T = V[1],
                        F = Object(a.useState)(!1),
                        N = Object(o.a)(F, 2),
                        _ = N[0],
                        W = N[1],
                        G = Object(a.useState)(!1),
                        B = Object(o.a)(G, 2),
                        R = B[0],
                        U = B[1];
                    Object(a.useEffect)(
                        function () {
                            "kids" === n ? P && H(!0) : "adults" === n && "male" === c ? P && _ && R && H(!0) : "adults" === n && "female" === c && P && _ && H(!0);
                        },
                        [P, _, R]
                    );
                    var K = Object(a.useState)(void 0),
                        J = Object(o.a)(K, 2),
                        Q = J[0],
                        X = J[1],
                        Y = Object(a.useState)(void 0),
                        Z = Object(o.a)(Y, 2),
                        $ = Z[0],
                        ee = Z[1],
                        te = Object(a.useState)(void 0),
                        ne = Object(o.a)(te, 2),
                        ae = ne[0],
                        re = ne[1],
                        ie = Object(a.useState)(void 0),
                        ce = Object(o.a)(ie, 2),
                        se = ce[0],
                        ue = ce[1],
                        le = Object(a.useState)(void 0),
                        de = Object(o.a)(le, 2),
                        pe = de[0],
                        me = de[1],
                        fe = Object(a.useState)(void 0),
                        he = Object(o.a)(fe, 2),
                        xe = he[0],
                        be = he[1];
                    Object(a.useEffect)(
                        function () {
                            "cm" === v
                                ? (void 0 !== h.height && X(h.height), void 0 !== h.chest && ue(h.chest), void 0 !== h.waist && me(h.waist))
                                : (void 0 !== h.height && (console.log("updating inputHeightFT to " + y(h.height)[0]), ee(y(h.height)[0]), console.log("updating inputHeightIN to " + y(h.height)[1]), re(y(h.height)[1])),
                                  void 0 !== h.chest && ue(O(h.chest)),
                                  void 0 !== h.waist && me(O(h.waist))),
                                "uk" === E ? void 0 !== h.dressSize && be(h.dressSize) : "eu" === E && void 0 !== h.dressSize && be(h.dressSize + 28);
                        },
                        [h.height, h.chest, h.waist, h.dressSize, v, E]
                    );
                    var Se = Object(a.useState)(!1),
                        ve = Object(o.a)(Se, 2),
                        je = ve[0],
                        Oe = ve[1];
                    Object(a.useEffect)(
                        function () {
                            Oe(
                                "kids" === n
                                    ? "cm" === v
                                        ? !!Q
                                        : !((!$ && 0 !== $) || (!ae && 0 !== ae))
                                    : "adults" === n && "male" === c
                                    ? "cm" === v
                                        ? !!(Q && se && pe)
                                        : !((!$ && 0 !== $) || (!ae && 0 !== ae) || !se || !pe)
                                    : !("adults" !== n || "female" !== c || ("cm" === v ? !Q || !xe : (!$ && 0 !== $) || (!ae && 0 !== ae) || !xe))
                            );
                        },
                        [n, c, Q, v, se, pe, $, ae, xe]
                    );
                    var ye = function () {
                            var t = Q,
                                n = se,
                                a = pe,
                                r = 2 * Math.round(xe / 2);
                            "cm" !== v && ((t = 30.48 * $ + j(ae)), (n = j(se)), (a = j(pe))),
                                "eu" === E ? (r = xe - 28) : "us" === E && (r = xe + 2),
                                x(function (e) {
                                    return Object(g.a)(Object(g.a)({}, e), {}, { height: t, chest: n, waist: a, dressSize: r });
                                }),
                                e.updateCurrentSlide(e.currentSlide + 1);
                        },
                        we = Object(oe.useMediaQuery)({ query: "(max-width: 1024px)" }),
                        ze = Object(a.useState)(0),
                        ke = Object(o.a)(ze, 2),
                        Ee = ke[0],
                        Ce = ke[1],
                        Ae = {};
                    return (
                        0 !== e.currentSlide ? (Ae["data-track"] = "".concat(n, "-").concat(e.currentSlide + 1, "-measurements-continue")) : (Ae["data-track"] = "".concat(e.currentSlide + 1, "-measurements-continue")),
                        r.a.createElement(
                            A,
                            { currentSlide: e.currentSlide, updateCurrentSlide: e.updateCurrentSlide, imagesHaveLoaded: L },
                            r.a.createElement(De, null, "What are your measurements?"),
                            r.a.createElement(Ve, null, "Please input your measurements."),
                            r.a.createElement(q, {
                                values: ["cm", "inches"],
                                text: ["CM", "Inches"],
                                currentState: v,
                                switchAction: function () {
                                    w("cm" === v ? "inches" : "cm"),
                                        x(function (e) {
                                            return Object(g.a)(Object(g.a)({}, e), {}, { height: "", chest: "", waist: "", dressSize: "" });
                                        });
                                },
                                isRowMobile: !0,
                                currentSlide: e.currentSlide,
                            }),
                            "adults" === n &&
                                r.a.createElement(ge, {
                                    states:
                                        "male" === c
                                            ? [
                                                  { value: 0, text: "Height" },
                                                  { value: 1, text: "Chest" },
                                                  { value: 2, text: "Waist" },
                                              ]
                                            : [
                                                  { value: 0, text: "Height" },
                                                  { value: 1, text: "Dress Size" },
                                              ],
                                    currentState: Ee,
                                    switchAction: Ce,
                                }),
                            "adults" === n &&
                                "male" === c &&
                                r.a.createElement(
                                    Pe,
                                    null,
                                    r.a.createElement(Me, {
                                        inputType: "height",
                                        unitOfMeasurement: v,
                                        currentMobilePanel: Ee,
                                        inputHeading: "Height",
                                        panelImage: "https://cdn.shopify.com/s/files/1/0398/0253/files/HeightDryrobe.png",
                                        updateImageLoadStatus: T,
                                        inputValue: "cm" === v ? Q : [$, ae],
                                        updateInputValue: "cm" === v ? X : [ee, re],
                                    }),
                                    r.a.createElement(Me, {
                                        inputType: "chest",
                                        unitOfMeasurement: v,
                                        currentMobilePanel: Ee,
                                        inputHeading: "Chest",
                                        panelImage: "https://cdn.shopify.com/s/files/1/0398/0253/files/ChestDryrobe.png",
                                        updateImageLoadStatus: W,
                                        inputValue: se,
                                        updateInputValue: ue,
                                    }),
                                    r.a.createElement(Me, {
                                        inputType: "waist",
                                        unitOfMeasurement: v,
                                        currentMobilePanel: Ee,
                                        inputHeading: "Waist",
                                        panelImage: "https://cdn.shopify.com/s/files/1/0398/0253/files/WaistDryrobe.png",
                                        updateImageLoadStatus: U,
                                        inputValue: pe,
                                        updateInputValue: me,
                                    })
                                ),
                            "adults" === n &&
                                "female" === c &&
                                r.a.createElement(
                                    Pe,
                                    null,
                                    r.a.createElement(Me, {
                                        inputType: "height",
                                        unitOfMeasurement: v,
                                        currentMobilePanel: Ee,
                                        inputHeading: "Height",
                                        panelImage: "https://cdn.shopify.com/s/files/1/0398/0253/files/Female_HeightDryrobe.png",
                                        updateImageLoadStatus: T,
                                        inputValue: "cm" === v ? Q : [$, ae],
                                        updateInputValue: "cm" === v ? X : [ee, re],
                                    }),
                                    r.a.createElement(Me, {
                                        inputType: "dressSize",
                                        unitOfMeasurement: v,
                                        currentMobilePanel: Ee,
                                        inputHeading: "Dress size",
                                        panelImage: "https://cdn.shopify.com/s/files/1/0398/0253/files/Female_DressDryrobe.png",
                                        updateImageLoadStatus: W,
                                        inputValue: xe,
                                        updateInputValue: be,
                                        unitOfDressSize: E,
                                        updateUnitOfDressSize: C,
                                    })
                                ),
                            "kids" === n &&
                                r.a.createElement(
                                    Pe,
                                    null,
                                    r.a.createElement(Me, {
                                        inputType: "height",
                                        unitOfMeasurement: v,
                                        currentMobilePanel: Ee,
                                        inputHeading: "Height",
                                        panelImage: "male" === c ? "https://cdn.shopify.com/s/files/1/0398/0253/files/HeightDryrobe.png" : "https://cdn.shopify.com/s/files/1/0398/0253/files/Female_HeightDryrobe.png",
                                        updateImageLoadStatus: T,
                                        inputValue: "cm" === v ? Q : [$, ae],
                                        updateInputValue: "cm" === v ? X : [ee, re],
                                    })
                                ),
                            r.a.createElement(
                                Te,
                                Object.assign(
                                    {
                                        measurementsAreValid: je,
                                        isMobile: we,
                                        onClick: function () {
                                            we ? ((("adults" === n) & ("female" === c) && 1 !== Ee) || (("adults" === n) & ("male" === c) && 2 !== Ee) ? Ce(Ee + 1) : je ? ye() : Ce(0)) : ye();
                                        },
                                    },
                                    Ae
                                ),
                                je ? "Continue" : we ? "Next" : "Input measurements"
                            )
                        )
                    );
                },
                Ne = n(8),
                _e = n.n(Ne),
                We = n(17);
            function Ge() {
                var e = Object(f.a)([
                    "\n  height: 40px;\n  width: 240px;\n\n  border: none;\n  margin-top: 20px;\n  margin-bottom: 15px;\n\n  background-color: #ed523e;\n\n  color: #fff;\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: bold;\n\n  cursor: pointer;\n\n  @media (max-width: 1024px) {\n    height: 36px;\n  }\n",
                ]);
                return (
                    (Ge = function () {
                        return e;
                    }),
                    e
                );
            }
            function qe() {
                var e = Object(f.a)(["\n  color: #d70000;\n  font-weight: bold;\n  text-decoration: none;\n"]);
                return (
                    (qe = function () {
                        return e;
                    }),
                    e
                );
            }
            function Be() {
                var e = Object(f.a)(["\n  margin: 0 0 6px;\n\n  font-size: 15px;\n  color: #666;\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    margin-left: 7.5px;\n    margin-right: 7.5px;\n    font-size: 12px;\n  }\n"]);
                return (
                    (Be = function () {
                        return e;
                    }),
                    e
                );
            }
            function Re() {
                var e = Object(f.a)(["\n  margin: 0;\n  font-size: 15px;\n  text-align: center;\n  font-weight: bold;\n"]);
                return (
                    (Re = function () {
                        return e;
                    }),
                    e
                );
            }
            function Ue() {
                var e = Object(f.a)(["\n  margin-top: 20px;\n  margin-bottom: 10px;\n"]);
                return (
                    (Ue = function () {
                        return e;
                    }),
                    e
                );
            }
            function Ke() {
                var e = Object(f.a)([
                    "\n  max-height: 460px;\n\n  @media (max-width: 1920px) {\n    max-height: 300px;\n  }\n\n  @media (max-width: 1440px) {\n    max-height: 210px;\n  }\n\n  @media (max-width: 1024px) {\n    max-height: 160px;\n  }\n",
                ]);
                return (
                    (Ke = function () {
                        return e;
                    }),
                    e
                );
            }
            function Je() {
                var e = Object(f.a)(["\n  margin-top: 0;\n  margin-bottom: 30px;\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    margin: 20px;\n    font-size: 21px;\n  }\n"]);
                return (
                    (Je = function () {
                        return e;
                    }),
                    e
                );
            }
            var Qe = h.a.h1(Je()),
                Xe = h.a.img(Ke()),
                Ye = h.a.div(Ue()),
                Ze = h.a.p(Re()),
                $e = h.a.p(Be()),
                et = h.a.a(qe()),
                tt = h.a.button(Ge()),
                nt = function (e) {
                    var t = Object(a.useContext)(s),
                        n = Object(o.a)(t, 1)[0],
                        i = Object(a.useContext)(d),
                        c = Object(o.a)(i, 1)[0],
                        u = Object(a.useState)({}),
                        l = Object(o.a)(u, 2),
                        p = (l[0], l[1]),
                        m = Object(a.useState)({}),
                        g = Object(o.a)(m, 2),
                        f = g[0],
                        h = g[1],
                        x = Object(a.useState)({}),
                        j = Object(o.a)(x, 2),
                        O = j[0],
                        y = j[1],
                        w = Object(a.useState)(!1),
                        z = Object(o.a)(w, 2),
                        k = z[0],
                        E = z[1],
                        C = Object(a.useState)("changing"),
                        M = Object(o.a)(C, 2),
                        I = M[0],
                        L = M[1],
                        H = Object(a.useState)("View available products"),
                        D = Object(o.a)(H, 2),
                        V = D[0],
                        P = D[1],
                        T = Object(a.useState)(),
                        F = Object(o.a)(T, 2),
                        N = F[0],
                        _ = F[1],
                        W = function (e) {
                            // console.log("\nChecking changing size data for a size match...");
                            var t = S(e.measurements["".concat(c.age)]["".concat(c.gender)].changing, c);
                            // console.log("\nChecking general size data for a size match...");
                            var n = S(e.measurements["".concat(c.age)]["".concat(c.gender)].general, c);
                            _(t === n ? t : [t, n]);
                        };
                    Object(a.useEffect)(
                        function () {
                            function e() {
                                return (e = Object(We.a)(
                                    _e.a.mark(function e() {
                                        return _e.a.wrap(function (e) {
                                            for (;;)
                                                switch ((e.prev = e.next)) {
                                                    case 0:
                                                        return (
                                                            // console.log("Fetching size data from Shopify servers..."), 
                                                            (e.next = 3), 
                                                            fetch("https://cdn.shopify.com/s/files/1/0398/0253/t/99/assets/measurements.json?v=".concat(Date.now()))
                                                        );
                                                    case 3:
                                                        e.sent
                                                            .json()
                                                            .then(function (e) {
                                                                p(e.measurements), h(e.measurementsImages), y(e.measurementMapping), W(e);
                                                            })
                                                            .catch(function (e) {
                                                                return console.error(e);
                                                            });
                                                    case 5:
                                                    case "end":
                                                        return e.stop();
                                                }
                                        }, e);
                                    })
                                )).apply(this, arguments);
                            }
                            !(function () {
                                e.apply(this, arguments);
                            })();
                        },
                        [c]
                    ),
                        Object(a.useEffect)(
                            function () {
                                !(function () {
                                    if (N) {
                                        var e = document.querySelector(".swatch-element.".concat(v(N, I, O).letter)),
                                            t = "";
                                        try {
                                            t = document.getElementsByClassName("product-single__title")[0].textContent.toLowerCase();
                                        } catch (e) {
                                            e instanceof TypeError ? console.warn("No product title can be found on the page - cannot determine this product page's style") : console.error(e);
                                        }
                                        e && !e.classList.contains("soldout") && t.includes(c.style) ? P("Select size") : P("View available products");
                                    }
                                })();
                            },
                            [I, c.style, O, N]
                        );
                    var G = {},
                        B = {};
                    return (
                        0 !== e.currentSlide ? (G["data-track"] = "".concat(n, "-").concat(e.currentSlide + 1, "-recommendations-continue")) : (G["data-track"] = "".concat(e.currentSlide + 1, "-continue")),
                        (B["data-track-recommendedsizetitle"] = Array.isArray(N) ? ("changing" === I ? N[0] : N[1]) : N),
                        r.a.createElement(
                            A,
                            { currentSlide: e.currentSlide, updateCurrentSlide: e.updateCurrentSlide, imagesHaveLoaded: k },
                            r.a.createElement(Qe, null, "Our Recommendations"),
                            Array.isArray(N) &&
                                r.a.createElement(q, {
                                    values: ["changing", "general"],
                                    text: ["For changing", "For general use"],
                                    currentState: I,
                                    switchAction: L,
                                    images: [f["".concat(c.age)]["".concat(c.gender)]["".concat(c.style)]["".concat(N[0])], f["".concat(c.age)]["".concat(c.gender)]["".concat(c.style)]["".concat(N[1])]],
                                    updateImageLoadStatus: E,
                                    currentSlide: e.currentSlide,
                                }),
                            !Array.isArray(N) &&
                                r.a.createElement(Xe, {
                                    src: N && f["".concat(c.age)]["".concat(c.gender)]["".concat(c.style)]["".concat(N)],
                                    onLoad: function () {
                                        return E(!0);
                                    },
                                }),
                            r.a.createElement(
                                Ye,
                                null,
                                "adults" === c.age ? r.a.createElement(Ze, null, "long" === c.style ? "dryrobe Advance Long Sleeve" : "dryrobe advance Short Sleeve") : r.a.createElement(Ze, null, "dryrobe Advance"),
                                r.a.createElement(Ze, null, "Size:", " ", Array.isArray(N) ? ("changing" === I ? N[0] : N[1]) : N)
                            ),
                            r.a.createElement(
                                $e,
                                null,
                                "changing" === I ? "A loose fit that will allow easy changing while staying dry, warm and protected from the elements." : "Great for keeping warm and dry, where changing space is not required."
                            ),
                            r.a.createElement($e, null, "dryrobes are robust and designed to go over wet clothes and whole outfits."),
                            r.a.createElement(
                                tt,
                                Object.assign(
                                    {
                                        className: "selectSize",
                                        onClick: function () {
                                            return (function () {
                                                sessionStorage.setItem("recommended_size", v(N, I, O).number);
                                                var e = document.querySelector(".swatch-element.".concat(v(N, I, O).letter)),
                                                    t = "";
                                                try {
                                                    t = document.getElementsByClassName("product-single__title")[0].textContent.toLowerCase();
                                                } catch (e) {
                                                    e instanceof TypeError ? console.warn("No product title can be found on the page - cannot determine this product page's style") : console.error(e);
                                                }
                                                e && !e.classList.contains("soldout") && t.includes(c.style)
                                                    ? (console.log("Product is available, selecting"), e.querySelector("input").click(), b())
                                                    : (console.log("Size variant is sold out or does not exist for this product (cannot find swatch) - redirecting"),
                                                      (function (e, t, n, a) {
                                                          console.log("Redirecting to product grid page..."),
                                                              "kids" === e.age
                                                                  ? t.includes("Kids")
                                                                      ? (window.location.href = "/collections/kids-dryrobe")
                                                                      : (window.location.href = "/collections/adults")
                                                                  : (console.log("Two fits recommended: ".concat(t)),
                                                                    console.log("Selected: ".concat(n, "; redirecting to corresponding grid")),
                                                                    (window.location.href = "/pages/fit-recommender-results?type=".concat(e.style, "&size=").concat(v(t, n, a).number, "&age=").concat(v(t, n, a).age)));
                                                      })(c, N, I, O));
                                            })();
                                        },
                                    },
                                    G,
                                    B
                                ),
                                V
                            ),
                            r.a.createElement($e, null, "If you need further advice on sizing, please", " ", r.a.createElement(et, { href: "/pages/contact-us" }, "contact us"), " and we will be happy to help.")
                        )
                    );
                };
            c.a.render(
                r.a.createElement(
                    r.a.StrictMode,
                    null,
                    r.a.createElement(function () {
                        var e = Object(a.useState)("adults"),
                            t = Object(a.useState)("male"),
                            n = Object(a.useState)("long"),
                            i = Object(a.useState)("cm"),
                            c = Object(a.useState)("uk"),
                            g = Object(a.useState)({ age: "adults", style: "long", gender: "male", height: void 0, chest: void 0, waist: void 0, dressSize: void 0 }),
                            f = Object(a.useState)(0),
                            h = Object(o.a)(f, 2),
                            x = h[0],
                            b = h[1],
                            S = [
                                r.a.createElement(J, { currentSlide: x, updateCurrentSlide: b }),
                                r.a.createElement(te, { currentSlide: x, updateCurrentSlide: b }),
                                r.a.createElement(ce, { currentSlide: x, updateCurrentSlide: b }),
                                r.a.createElement(Fe, { currentSlide: x, updateCurrentSlide: b }),
                                r.a.createElement(nt, { currentSlide: x, updateCurrentSlide: b }),
                            ];
                        return r.a.createElement(
                            s.Provider,
                            { value: e },
                            r.a.createElement(
                                u.Provider,
                                { value: t },
                                r.a.createElement(l.Provider, { value: n }, r.a.createElement(p.Provider, { value: i }, r.a.createElement(m.Provider, { value: c }, r.a.createElement(d.Provider, { value: g }, S[x]))))
                            )
                        );
                    }, null)
                ),
                document.getElementById("fit")
            );
        },
    },
    [[18, 1, 2]],
]);
